import React from 'react';
import { Button } from 'web-library';


import { makeStyles } from 'tss-react/mui';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { candidateService } from '../../../../api';
import TransactionDetail from '../TransactionDetail';
import RouteKey from '../../../../routes/key';

const useStyles = makeStyles()((theme) =>
({
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(2),
  },
}));

const { amendment } = RouteKey.child;
const { coordinatorExamRegistrations } = RouteKey.amendment.child;

export interface ResitReceiptProps {
  internalTransactionRef: string;
}

const ResitReceipt = ({ internalTransactionRef }: ResitReceiptProps) => {
  const { classes } = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const { data } = candidateService.resit.coordinator.useSimplePaymentDetail(
    () => {
      // do nothing
    },
    () => {
      // do nothing
    },
    internalTransactionRef
  );

  return (
    <>
      <TransactionDetail transaction={data} hideTitle />

      <Button
        id="button-resitReceipt-goToRegisteredExams"
        className={classes.button}
        onClick={() => history.push(`/${amendment}/${coordinatorExamRegistrations.route}`)}
      >
        {t('resit->>ResitReceipt.View Registered Exams')}
      </Button>
    </>
  );
};

export default ResitReceipt;
